import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { updateMember, inviteLink } from "@/lib/dentiumApi";

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Enlace de invitación copiado", { description: "Envíalo a la persona invitada." });
  } catch {
    window.prompt("Copia el enlace de invitación:", text);
  }
};

const ROLE = { admin: "Administrador", recepcion: "Recepción" };
const STATUS = {
  activo: "bg-emerald-50 text-emerald-700 border-emerald-200",
  invitado: "bg-[#F1EBE1] text-[#8A7352] border-[#E0D3BC]",
  desactivado: "bg-red-50 text-red-600 border-red-200",
};
const STATUS_LABEL = { activo: "Activo", invitado: "Invitación pendiente", desactivado: "Desactivado" };

export const TeamMemberRow = ({ member: u, isSelf }) => {
  const qc = useQueryClient();
  const toggle = useMutation({
    mutationFn: (active) => updateMember(u.id, { active }),
    onSuccess: (d) => {
      qc.invalidateQueries({ queryKey: ["team"] });
      toast.success(d.active ? "Usuario activado" : "Usuario desactivado");
    },
    onError: (e) => toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "No se pudo actualizar el usuario"),
  });

  return (
    <div className="flex flex-wrap items-center gap-3 px-4 py-3" data-testid={`team-member-${u.email}`}>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-[#1A1A1A] truncate">{u.name || u.email}{isSelf && <span className="text-[#A79E90] font-normal"> (tú)</span>}</div>
        <div className="text-xs text-[#8A7E70] truncate">{u.email} · {ROLE[u.role] || u.role}</div>
      </div>
      <span data-testid="team-member-status" className={`text-[11px] font-medium rounded-full border px-2.5 py-1 ${STATUS[u.status]}`}>{STATUS_LABEL[u.status]}</span>
      {u.status === "invitado" && u.invite_token && (
        <button data-testid="copy-invite-link-btn" onClick={() => copyText(inviteLink(u.invite_token))} title="Copiar enlace de invitación"
          className="h-8 w-8 rounded-full flex items-center justify-center text-[#6B6157] hover:bg-[#F1EBE1] transition-colors">
          <Link2 className="h-4 w-4" />
        </button>
      )}
      {!isSelf && (
        <Switch data-testid="team-member-active-switch" checked={u.active} disabled={toggle.isPending}
          onCheckedChange={(v) => toggle.mutate(v)} title={u.active ? "Desactivar usuario" : "Activar usuario"} />
      )}
    </div>
  );
};
